/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation view
**********************************************************/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { dynamicSort, dynamicReverseSort } from '../utils';
import { fetchIrrigation, fetchEmployees, fetchIrrigationReport, resetDashboard,
 _error } from './irrigation_actions';
import ReportForm from './components/report_form';
import FooterModal from './components/footer_modal';
import IrrigationDisplay from './components/irrigation_display';
import IrrigationDashboard from './irrigation_dashboard';

const propTypes = {
  employees: PropTypes.array,
  engines: PropTypes.array,
  meters: PropTypes.array,
  valves: PropTypes.array,
  user: PropTypes.object,
  fetchIrrigation: PropTypes.func,
  fetchEmployees: PropTypes.func
};

const TDList = ({ list, log, id, prop, _class }) => {
  if (!log) return <td></td>;
  return (
    <td className={_class}>
      {
        log.map((m, ind) => {
          let _m = list.find((l) => l.id === m[id]);
          if (ind === log.length - 1) return <span key={m.id}>{ _m[prop] }</span>;
          else return <span key={m.id}>{ _m[prop] }, </span>;
        })
      }
    </td>
  )
}

class IrrigationView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      irrigation: this.props.irrigationLogs,
      reverseSort: false
    }
    this.sortBy = this.sortBy.bind(this);
  }
  componentDidMount() {
    if (this.props.engines.length === 0) this.props.fetchIrrigation();
    if (this.props.employees.length === 0) this.props.fetchEmployees();
  }
  sortBy(id) {
    if (!id) return;
    let _id = id.split('-');
    if (this.state.reverseSort) this.setState({ reverseSort: !this.state.reverseSort }, () => {
      this.setState({ irrigation: this.state.irrigation.sort(dynamicReverseSort(_id[1])) })
    });
    this.setState({ irrigation: this.state.irrigation.sort(dynamicSort(_id[1])), reverseSort: !this.state.reverseSort });
  }
  render() {
    return (
      <div>
        {
          this.props.dashboard ?
          <div className="row">
            <div className="col s12 m12 l12 xl12">
              <span className="left flow-text">Dates Selected: <b>{ this.props.dashboardData.startDate } -> { this.props.dashboardData.endDate }</b></span>
              <span className="right pb-1"><button onClick={() => this.props.resetDashboard()} className="btn waves-effect">Fetch New Report</button></span>
            </div><hr />
            <div className="col s12 m12 l12 xl12">
              <IrrigationDashboard dashboardData={this.props.dashboardData} />
            </div>
          </div>
          :
          <div className="row">
            <div className="col s12 m12 l12 xl2">
              <div className="card z-depth-2">
                <div className="card-content">
                  <span className="card-title report-title"><center><u>Irrigation Report</u></center></span>
                  <span></span>
                  <ReportForm fetchIrrigationReport={this.props.fetchIrrigationReport} user={this.props.user} error={this.props._error} />
                </div>
              </div>
            </div>
            <div className="col s12 m12 l12 xl10">
              {
                this.props.irrigationLogs.length > 0 ?
                <div className="irrigation-table">
                  <table className="bordered highlight responsive-table centered">
                    <thead>
                      <tr>
                        <th id={'i-date'} onClick={(e) => this.sortBy(e.target.id)}>Date</th>
                        <th id={'h-engineLog'} onClick={(e) => this.sortBy(e.target.id)}>Engine</th>
                        <th id={'h-meterLog'} onClick={(e) => this.sortBy(e.target.id)}>Meter</th>
                        <th id={'h-valveLog'} onClick={(e) => this.sortBy(e.target.id)}>Valve</th>
                        <th id={'h-totalEngineHours'} onClick={(e) => this.sortBy(e.target.id)}>Engine Hours</th>
                        <th id={'h-totalMeterGal'} onClick={(e) => this.sortBy(e.target.id)}>Meter Gallons (M)</th>
                        <th id={'h-totalValveHours'} onClick={(e) => this.sortBy(e.target.id)}>Valve Hours</th>
                        <th>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.props.irrigationLogs.map((i) => (
                          <tr key={i.id}>
                            <td>{ moment(i.date).format('MM-DD-YYYY') }</td>
                            <TDList log={i.engineLog} list={this.props.engines} id={'engineId'} prop={'equipmentNo'} />
                            <TDList log={i.meterLog} list={this.props.meters} id={'meterId'} prop={'meterNo'} />
                            <TDList log={i.valveLog} list={this.props.valves} id={'valveId'} prop={'valveNo'} _class={'valve-table-list'} />
                            <td>{ i.totalEngineHours }</td>
                            <td>{ i.totalMeterGal }</td>
                            <td>{ i.totalValveHours }</td>
                            <td>
                              <a className="waves-effect waves-light btn btn-small green modal-trigger" href={`#irrigation-log-${i.id}`}>
                                View
                              </a>
                              {
                                FooterModal(IrrigationDisplay)
                                // eslint-disable-next-line
                                ({
                                  id: `irrigation-log-${i.id}`,
                                  employees: this.props.employees,
                                  engines: this.props.engines,
                                  meters: this.props.meters,
                                  valves: this.props.valves,
                                  app: { data: { ...i }, engineLog: i.engineLog, meterLog: i.meterLog, valveLog: i.valveLog },
                                  view: true,
                                  toDelete: false,
                                  footer: true
                                })
                              }
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
                : ''
              }
            </div>
          </div>
        }
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    dashboard: state.irrigation.view.dashboard,
    dashboardData: state.irrigation.view.dashboardData,
    employees: state.irrigation.utils.employees,
    engines: state.irrigation.utils.engines,
    irrigationLogs: state.irrigation.view.displaying,
    meters: state.irrigation.utils.meters,
    user: state.auth.user,
    valves: state.irrigation.utils.valves
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    _error,
    fetchEmployees,
    fetchIrrigation,
    fetchIrrigationReport,
    resetDashboard
  }, dispatch);
}

IrrigationView.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(IrrigationView);



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/irrigation_view.js